import { useState, useRef } from 'react'
import { LuCopy, LuTrash2 } from "react-icons/lu";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAuth } from "../contexts/AuthContext";
import { useTranslation } from '../hooks/useTranslation';
import { useOutletContext } from 'react-router-dom';
import { Card, Button } from '../components/primitives';
import Modal from '../components/portals/Modal';

export default function ChannelCard({ channel, channelId, workspaceId, workspaceType, handleChannelDelete }) {
    const t = useTranslation();
    const [copied, setCopied] = useState(false);
    const { url } = useAuth();
    const identifier = workspaceType === 1 ? `${workspaceId}_${channel.teamId}_${channelId}` : `${workspaceId}_${channelId}`;
    const embed = `<script src="${url}/${workspaceType}/${identifier}.js"></script>`;
    const { mobile } = useOutletContext();
    const [showDelete, setShowDelete] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const cardRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);

    const intervalRef = useRef(false);

    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    };

    const handleTouchMove = (e) => {
        if (mobile) {
            const currentX = e.touches[0].clientX;
            const diff = startX - currentX;
            
            // If dragged more than 20px, show delete button
            if (diff > 20 && !isDragging) {
                setIsDragging(true);
                setShowDelete(true);
            }

            if (diff < -20 && !isDragging) {
                setIsDragging(false);
                setShowDelete(false);
            }
        }
    };

    const handleTouchStart = (e) => {
        if (mobile) {
            setStartX(e.touches[0].clientX);
            setIsDragging(false);
        }
    };

    function handleHover(type) {
        if (!mobile) {
            if (type) {
                intervalRef.current = true;
                setTimeout(() => setShowDelete(intervalRef.current), 500);
            } else {
            intervalRef.current = false;
                setTimeout(() => setShowDelete(intervalRef.current), 2000);
            }
        }
    }

    async function handleDelete() {
        setLoading(true);
        await handleChannelDelete(channelId);
        setLoading(false);
    }

    return (
        <>
        <div className="input-settings-group-inner-row"
            onMouseEnter={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
        >
            <div className={`channel-card ${showDelete ? 'channel-card-with-delete' : ''}`}
                ref={cardRef}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
            >
                <div className="channel-card-name-text">{channel.name}</div>
                <CopyToClipboard className="channel-card-button" text={embed} onCopy={handleCopy}>
                    <button>
                        <LuCopy className="copy-icon"/>
                        {copied ? t('Copied!') : t('Copy Link')}
                    </button>
                </CopyToClipboard>
            </div>
            {showDelete && (
                <button 
                    className="auto-card-delete-button" 
                    onClick={() => setIsOpen(true)}
                >
                    <LuTrash2 />
                </button>
            )}
        </div>
        <Modal open={isOpen} onClickOutside={() => setIsOpen(false)}>
            <Card className='white'>
                <Card.Header>
                    <h2>{t('Delete Channel')}</h2>
                </Card.Header>
                <Card.Body>
                    <p>{t(`Are you sure you want to delete ${channel.name}?`)}</p>
                    <Button onClick={handleDelete} loading={loading} className='submit'>{t('Delete Channel')}</Button>
                    <Button onClick={() => setIsOpen(false)}>{t('Cancel')}</Button>
                </Card.Body>
            </Card>
        </Modal>
        </>
    );
}

// Unclear where this functionality will go. Stored here for now.
/* <Button 
    onClick={() => setShowScript(prev => !prev)}
    className="channel-name-button"
>
    {showScript ? embed : channel.name}
</Button> */